<template>
  <div class="adv-listing-filters-clear">
    <a :href="getUrlNoFilters" class="adv-listing-filters-clear-btn fw-700">{{ t('filters.clear.all') }}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedFiltersClear',
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ])
  }
}
</script>

<style lang="scss" scoped>
.adv-listing-filters-clear {
  position: relative;
  display: grid;
  align-items: center;
  width: fit-content;
  height: 100%;
  padding:0 10px;
  margin-left:5px;
  transition: all 300ms ease-in-out;
  &-btn {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 13px;
    line-height: 1.2;
    color: black;
  }
  @media screen and (max-width: 1199px) {
    position: fixed;
    display: none;
    bottom: 0;
    margin: 0;
    left: 0;
    right: 0;
    padding: 10px 0;
    background-color: #ffffff;
    z-index: 2;
    box-shadow: 0 -3px 6px #00000029;
    height: 82px;
    a {
      text-align: center;
      background-color: #000000;
      color: #ffffff;
      max-width: 80%;
      margin: 0 auto;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
    }
  }
}

.adv-listing-filters-clear.visible {
  display: grid;
  width: 100%;
  opacity: 1;
}
</style>
